import React from 'react';
import { Skeleton } from '@mui/material';
import styles from './PlanHeroCard.module.css';

/** Esqueleto do card principal enquanto a assinatura carrega. */
const PlanHeroSkeleton = () => (
  <section className={styles.hero} aria-busy="true">
    <div className={styles.top}>
      <Skeleton variant="text" width={70} />
      <Skeleton variant="rounded" width={90} height={24} sx={{ borderRadius: '999px' }} />
    </div>
    <div className={styles.identity}>
      <Skeleton variant="text" width="45%" height={44} />
      <Skeleton variant="text" width={140} />
    </div>
    <div className={styles.facts}>
      <Skeleton variant="rounded" height={64} sx={{ borderRadius: '12px' }} />
    </div>
    <div className={styles.actions}>
      <Skeleton variant="rounded" width={130} height={40} sx={{ borderRadius: '10px' }} />
      <Skeleton variant="rounded" width={150} height={40} sx={{ borderRadius: '10px' }} />
    </div>
  </section>
);

export default PlanHeroSkeleton;
